import { CgAttachment } from 'react-icons/cg';

type AttachmentData = {
  id: string;
  name: string;
  url: string;
};

export function AttachmentList({
  attachments,
}: {
  attachments: Array<AttachmentData>;
}) {
  if (!attachments || attachments.length <= 0) return <></>;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        gap: '0.5rem',
        flexWrap: 'wrap',
      }}
    >
      {attachments?.map((attachment) => (
        <a
          key={`${attachment.id}`}
          href={attachment?.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            padding: 4,
            borderRadius: 5,
            border: '1px solid #e2e8f0',
            fontSize: '0.85rem',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <CgAttachment />
            {attachment?.name || `Anexo`}
          </div>
        </a>
      ))}
    </div>
  );
}
